import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './dashboard.css';
import App from './App';
import '@fortawesome/fontawesome-free/css/all.min.css';
import store from 'store/configureStore';
import { Provider } from 'react-redux';
import { UserProvider } from './context/UserContext'; // adjust path if needed

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <UserProvider>
        <App />
      </UserProvider>
    </Provider>
  </React.StrictMode>
);
